export class ShopEnvironment {
  public static getName = () => 'benzinga-shop';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://accounts.benzinga.com/api/v1/'),
  });
}
